import { render, staticRenderFns } from "./UserFinanceStatistic.vue?vue&type=template&id=780e2c39&"
import script from "./UserFinanceStatistic.vue?vue&type=script&lang=js&"
export * from "./UserFinanceStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports